import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';

// Components
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import styles from './nxSelectStyles';

function NoOptionsMessage(props) {
  /* eslint-disable react/prop-types */
  const { selectProps, children, innerProps } = props;
  return (
    <Typography
      // variant="subtitle1"
      gutterBottom
      color="textSecondary"
      className={selectProps.classes.noOptionsMessage}
      {...innerProps}
    >
      {selectProps.inputValue.length > 0 ? children : 'Ingresa por lo menos 3 caracteres para iniciar la búsqueda'}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  const { selectProps, innerRef, children, innerProps } = props;
  return (
    <>
      <TextField
        fullWidth
        InputProps={{
          inputComponent,
          inputProps: {
            ...innerProps,
            className: selectProps.classes.input,
            inputRef: innerRef,
            children
          }
        }}
        {...selectProps.textFieldProps}
      />
      <p className={selectProps.classes.helpText}>{selectProps.placeholder}</p>
    </>
  );
}

function Option(props) {
  const { innerRef, innerProps, isFocused, isSelected, children } = props;
  return (
    <MenuItem
      buttonRef={innerRef}
      selected={isFocused}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400
      }}
      {...innerProps}
    >
      {children}
    </MenuItem>
  );
}

function Placeholder(props) {
  const { children, innerProps, selectProps } = props;
  return (
    <Typography
      gutterBottom
      color="textSecondary"
      className={selectProps.required ? selectProps.classes.placeholderError : selectProps.classes.placeholder}
      {...innerProps}
    >
      {children}
    </Typography>
  );
}

function SingleValue(props) {
  const { selectProps, innerProps, children } = props;
  return (
    <Typography variant="subtitle1" gutterBottom className={selectProps.classes.singleValue} {...innerProps}>
      {children}
    </Typography>
  );
}

function ValueContainer(props) {
  const { selectProps, children } = props;
  return <div className={selectProps.classes.valueContainer}>{children}</div>;
}

function MultiValue(props) {
  const { selectProps, isFocused, removeProps, children } = props;
  return (
    <Chip
      tabIndex={-1}
      label={children}
      className={classNames(selectProps.classes.chip, {
        [selectProps.classes.chipFocused]: isFocused
      })}
      onDelete={removeProps.onClick}
      deleteIcon={<CancelIcon {...removeProps} />}
    />
  );
}

function Menu(props) {
  const { selectProps, innerProps, children } = props;
  return (
    <Paper square className={selectProps.classes.paper} {...innerProps}>
      {children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
};

export function NxSelectAsync(props) {
  const {
    classes = {},
    theme = {},
    placeholder,
    name,
    handleLoadOptions,
    handleChange,
    isMulti,
    isDisabled,
    value,
    required
  } = props;
  const selectStyles = {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      '& input': {
        font: 'inherit'
      }
    })
  };

  return (
    <div className={classes.root}>
      <AsyncSelect
        required={required}
        classes={classes}
        styles={selectStyles}
        textFieldProps={{
          InputLabelProps: {
            shrink: true
          }
        }}
        components={components}
        name={name}
        placeholder={placeholder}
        isClearable
        isDisabled={isDisabled}
        isMulti={isMulti}
        // cacheOptions
        value={value}
        loadOptions={handleLoadOptions}
        onChange={handleChange}
        noOptionsMessage={() => 'No se encontraron coincidencias'}
        loadingMessage={() => 'Buscando...'}
      />
    </div>
  );
}

NxSelectAsync.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object.isRequired,
  handleLoadOptions: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.any // -> expect array or object
};

NxSelectAsync.defaultProps = {
  placeholder: 'Selecciona una opción',
  isMulti: false,
  isDisabled: false,
  required: false,
  classes: {}
};

export default withStyles(styles, { withTheme: true })(NxSelectAsync);
